/**
 * Blog Hero Section
 *
 * Hero section for the blog with title, description, and search.
 */
'use client';

import React, { useState } from 'react';
import { Search } from 'lucide-react';

export default function BlogHeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement search functionality
    console.log('Searching for:', searchQuery);
  };

  return (
    <section
      className="
        relative w-full overflow-hidden
        h-[488px] sm:h-[600px] lg:h-[788px]          /* keep 788 on ≥1024 */
        bg-[linear-gradient(0deg,rgba(0,0,0,0.3)_0%,rgba(0,0,0,0.3)_100%),url(/images/blog/Andoria-AI-technology-blogHero.webp)]
        bg-cover bg-center
      "
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50" />

      <div className="relative flex flex-col items-center justify-center h-full gap-6 sm:gap-8 lg:gap-12 px-4 sm:px-6">
        {/* Title: 6xl on desktop, 4xl tablet, 3xl mobile */}
        <h1
          className="
            font-manrope font-bold text-white text-center tracking-tight leading-tight
            text-3xl sm:text-4xl lg:text-6xl
            max-w-2xl sm:max-w-3xl lg:max-w-4xl
            animate-fade-in
          "
        >
          The Andoria AI Blog
        </h1>

        {/* Sub-title: 2xl desktop, xl tablet, lg mobile */}
        <p
          className="
            font-manrope font-normal text-white/80 text-center
            text-lg sm:text-xl lg:text-2xl
            max-w-xl sm:max-w-2xl
            animate-slide-up
          "
          style={{ animationDelay: '0.2s' }}
        >
          Insights on AI, data, cloud, and digital marketplaces
        </p>

        {/* Search bar: full width until 2xl max-width */}
        <form
          onSubmit={handleSearch}
          className="
            w-full max-w-xl sm:max-w-2xl
            animate-slide-up
          "
          style={{ animationDelay: '0.4s' }}
        >
          <div
            className="
              flex items-center gap-3 sm:gap-4
              px-4 py-3 sm:px-5 sm:py-4 lg:px-6 lg:py-5
              bg-white/10 backdrop-blur-md
              rounded-full border-2 border-white/20
            "
          >
            <Search className="w-4 h-4 sm:w-5 sm:h-5 text-white shrink-0" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search articles, topics or authors..."
              className="
                flex-1 bg-transparent text-white placeholder:text-white/60
                outline-none font-manrope
                text-sm sm:text-base lg:text-lg
              "
            />
          </div>
        </form>
      </div>
    </section>
  );
}
